import { Product } from 'types/schema';
import Images from './Images';

export const getImageByCategory = (category?: Product['category']): string => {
  return Images[category?.parent?.name || 'Non-food'] || Images.NoImage;
};
